import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { POPUP_NAMES, POPUP_CITIES } from '../data/content';
function rand<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
const MINUTES = [2, 3, 5, 7, 8, 11, 14, 17, 21];
interface PopupData {
  name: string;
  city: string;
  minutes: number;
  key: number;
}
export function PurchasePopup() {
  const [data, setData] = useState<PopupData | null>(null);
  useEffect(() => {
    let counter = 0;
    let hideTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      counter += 1;
      setData({
        name: rand(POPUP_NAMES),
        city: rand(POPUP_CITIES),
        minutes: rand(MINUTES),
        key: counter
      });
      hideTimer = setTimeout(() => setData(null), 5000);
    };
    const first = setTimeout(show, 4000);
    const interval = setInterval(show, 13000);
    return () => {
      clearTimeout(first);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, []);
  return <div className="pointer-events-none fixed inset-x-0 bottom-4 z-50 flex justify-center px-4" data-id="element-125">
      <AnimatePresence data-id="element-126">
        {data && <motion.div key={data.key} initial={{
        opacity: 0,
        y: 40,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="pointer-events-auto flex w-full max-w-sm items-center gap-3 rounded-xl border border-[#F5C518]/40 bg-[#111] p-3 shadow-2xl" data-id="element-127">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#F5C518]/15" data-id="element-128">
              <CheckCircle2Icon className="h-6 w-6 text-[#F5C518]" data-id="element-129" />
            </div>
            <div className="flex-1" data-id="element-130">
              <p className="text-[13px] leading-tight text-white" data-id="element-131">
                <span className="font-700" data-id="element-132">{data.name}</span> de{' '}
                <span className="font-700" data-id="element-133">{data.city}</span> acaba de comprar{' '}
                <span className="text-[#F5C518]" data-id="element-134">HYROX Definitivo 360</span>
              </p>
              <p className="mt-0.5 text-[11px] text-neutral-400" data-id="element-135">
                Hace {data.minutes} minutos · Compra verificada
              </p>
            </div>
            <button type="button" onClick={() => setData(null)} aria-label="Cerrar notificación" className="shrink-0 text-neutral-500 hover:text-white" data-id="element-136">
              <XIcon className="h-4 w-4" data-id="element-137" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}